import React, { useState, useEffect } from "react";
import { Modal, Form, Input, message } from "antd";
import { CustomListService } from "../../Services/CustomListService";
import { TextService } from "../../Services/TextService";
import { WebApiCustomListsDtoCustomListDto } from "../../Repository/eventbookyapi";

interface EditCustomListModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    customList: WebApiCustomListsDtoCustomListDto;
}

const EditCustomListModal: React.FC<EditCustomListModalProps> = ({
    open,
    onClose,
    onSuccess,
    customList,
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const GetText = TextService.GetText;

    useEffect(() => {
        if (open && customList) {
            form.setFieldsValue({
                name: customList.name,
            });
        }
    }, [open, customList, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            await CustomListService.UpdateCustomList(customList.id!, {
                name: values.name,
            });

            message.success(GetText("CustomList_NameUpdated"));
            form.resetFields();
            onSuccess();
            onClose();
        } catch (error) {
            message.error(GetText("CustomList_FailedToUpdateName"));
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title={GetText("CustomList_EditName")}
            open={open}
            onOk={handleSubmit}
            onCancel={handleCancel}
            okText={GetText("Common_Save")}
            cancelText={GetText("Common_Cancel")}
            confirmLoading={loading}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label={GetText("CustomList_ListName")}
                    name="name"
                    rules={[
                        { required: true, message: GetText("Common_Required") },
                    ]}
                >
                    <Input placeholder={GetText("CustomList_ListName")} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditCustomListModal;
